import formatPrefixAuto from './format-prefix-auto';
import formatRounded from './format-rounded';
export default {
  "%": function _(a, b) {
    return (100 * a).toFixed(b);
  },
  b: function b(a) {
    return Math.round(a).toString(2);
  },
  c: function c(a) {
    return a + '';
  },
  d: function d(a) {
    return Math.round(a).toString(10);
  },
  e: function e(a, b) {
    return a.toExponential(b);
  },
  f: function f(a, b) {
    return a.toFixed(b);
  },
  g: function g(a, b) {
    return a.toPrecision(b);
  },
  o: function o(a) {
    return Math.round(a).toString(8);
  },
  p: function p(a, b) {
    return formatRounded(100 * a, b);
  },
  r: formatRounded,
  s: formatPrefixAuto,
  X: function X(a) {
    return Math.round(a).toString(16).toUpperCase();
  },
  x: function x(a) {
    return Math.round(a).toString(16);
  }
};